const tables = [
  {
    name: "Number",
  },
  {
    name: "Purchase",
  },
  {
    name: "Date",
  },
  {
    name: "Amount",
  },
  {
    name: "Payment",
  },
  {
    name: "Action",
  },
];

export default tables;
